import React, {useEffect, useState} from 'react';
import '../SellFactor.scss';
import commaSeparator from "../../../utils/CommaSeparator";
import {toast} from "react-toastify";
import {calculateTotalSum} from "../SellFactorFunctions";
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";


const CustomerUsedRemaining = ({setComponentData, componentData, initialData, setSendData, sendData}) => {

  const [maxRemaining, setMaxRemaining] = useState(0);
  const [currentMb, setCurrentMb] = useState(0)

  const checkSvg = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      fill="#DADADA"
      d="M14.19 0H5.81C2.17 0 0 2.17 0 5.81v8.37C0 17.83 2.17 20 5.81 20h8.37c3.64 0 5.81-2.17 5.81-5.81V5.81C20 2.17 17.83 0 14.19 0zm.59 7.7l-5.67 5.67a.75.75 0 01-1.06 0l-2.83-2.83a.754.754 0 010-1.06c.29-.29.77-.29 1.06 0l2.3 2.3 5.14-5.14c.29-.29.77-.29 1.06 0 .29.29.29.76 0 1.06z"
    ></path>
  </svg>

  const customerHandler = () => {

    if (sendData?.customerMobile.length < 11) {
      return toast.error("شماره تماس را وارد کنید.")
    }

    if (sendData?.discountCode === "") {
      return toast.error("کد تخفیف را وارد کنید.")
    }

    _axios.get(prefixUrl() + "/clothingShopFactor/?request=discountCodeData&mobile=" + sendData?.customerMobile + "&discountCode=" + sendData?.discountCode).then(res => {

      const data = res.data;
      if (data.status) {
        setMaxRemaining(+res.data.discountPrice)
      } else {
        toast.error(res.data.message)
        setMaxRemaining(0)
      }
    })
  }

  useEffect(() => {
    let sum = 0
    if (sendData?.tableData.length > 0) {
      sum = calculateTotalSum(sendData).sum
    } else {
      sum = +sendData?.servicePrice
    }

    if (sum < +maxRemaining) {
      setSendData({...sendData, usedRemaining: +sum})
    } else {
      setSendData({...sendData, usedRemaining: +maxRemaining})
    }

  }, [maxRemaining , currentMb , sendData?.tableData , sendData?.servicePrice , sendData?.totalDiscount]);

  return (
    <div className={"solid-dyna-input customer-club"}>
      <label className={"customer-club-label"}>باشگاه مشتریان</label>
      <div className={"grid-row"}>
        <div className={"solid-dyna-input"}>
          <label htmlFor="">کد تخفیف</label>
          <input
            placeholder={"کد تخفیف"}
            value={sendData?.discountCode !== "" ? sendData?.discountCode : ""}
            onChange={e => setSendData({...sendData, discountCode: e.target.value})}
          />
          <button type={"button"} className={`button-check-box ${maxRemaining === 0 ? "" : "active"}`} onClick={customerHandler}>
            {checkSvg}
          </button>
        </div>

        <div className={"solid-dyna-input"}>
          <label htmlFor="">مبلغ</label>
          <input
            disabled={sendData?.customerId === ""}
            placeholder={"0"}
            value={sendData?.usedRemaining !== "" ? commaSeparator(sendData?.usedRemaining) : ""}
            onChange={e => setCurrentMb(e.target.value)}
          />
        </div>
      </div>


    </div>
  );
};

export default CustomerUsedRemaining;